import { AxiosError } from 'axios';

import { venueRoles, merchantRoles, enterpriseRoles, brandRoles } from './constants';
import type { VenueRole, MerchantRole, EnterpriseRole, BrandRole } from './types';

const LOGIN_PREFIX = 'ipad_client_';

export const stripMerchantAppLoginPrefix = (login: string) => {
  return login.startsWith(LOGIN_PREFIX) ? login.substring(LOGIN_PREFIX.length) : login;
};

export function parseApiError(error: AxiosError<any>, defaultMessage?: string, useData?: boolean) {
  if (error && error.response && error.response.data) {
    if (error.response.status === 500) {
      return 'errors.network';
    } else if (error.response.status === 401) {
      return 'errors.unauthorized';
    } else if (error.response.status === 404) {
      return 'errors.notFound';
    }
    let msg = error.response.data.msg || error.response.data.error_description;
    if (useData && error.response.data && error.response.data.data) {
      msg += `. Data: ${error.response.data.data}`;
    }
    return msg;
  }
  if (defaultMessage) {
    return defaultMessage;
  }
  return 'errors.generic-server';
}

export const isVenueRole = (role: string): role is VenueRole => venueRoles.includes(role as VenueRole);
export const isMerchantRole = (role: string): role is MerchantRole => merchantRoles.includes(role as MerchantRole);
export const isEnterpriseRole = (role: string): role is EnterpriseRole =>
  enterpriseRoles.includes(role as EnterpriseRole);
export const isBrandRole = (role: string): role is BrandRole => brandRoles.includes(role as BrandRole);
